import theme, { size as sizeRaw } from './theme';

export const size = sizeRaw;
export default theme;
